import select from "@inquirer/select";
import input from "@inquirer/input";
import confirm from "@inquirer/confirm";

export interface AnswersType {
  type: string;
  scope: string;
  description: string;
  body: string[];
  issue: string;
}

export function askForType(): Promise<string> {
  return select({
    message: "type?",
    pageSize: 99,
    choices: [
      {
        name: "fix",
        value: "fix",
        description: "A bugfix",
      },
      {
        name: "feat",
        value: "feat",
        description: "A new feature",
      },
      {
        name: "refactor",
        value: "refactor",
        description: "A code change that neither fixes a bug nor adds a feature",
      },
      {
        name: "perf",
        value: "perf",
        description: "A code change that improves performance",
      },
      {
        name: "docs",
        value: "docs",
        description: "Documentation only changes",
      },
      {
        name: "style",
        value: "style",
        description: "Code style (semicolon, indentation, white-space, formatting, ...)",
      },
      {
        name: "test",
        value: "test",
        description: "add/change/delete tests",
      },
      {
        name: "chore",
        value: "chore",
        description: "Other changes that don't modify src or test files",
      },
      {
        name: "build",
        value: "build",
        description: "build system (npm, git, VSCode, tsconfig, angular.json, ...)",
      },
      {
        name: "ci",
        value: "ci",
        description: "CI configuration (GitHub, GitLab, RenovateBot, ...)",
      },
      {
        name: "revert",
        value: "revert",
        description: "Reverts a previous commit",
      },
    ],
  });
}

export function askForScope(): Promise<string> {
  return input({
    message: "scope?",
    validate: (value: string): string | boolean => {
      if (value.length > 20) {
        return `Your text is ${value.length - 20} char(s) too long.`;
      } else {
        return true;
      }
    },
  });
}

export function askForDescription(): Promise<string> {
  return input({
    message: "description?",
    validate: (value: string): string | boolean => {
      if (value.length > 70) {
        return `Your text is ${value.length - 70} char(s) too long.`;
      } else if (value.length < 3) {
        return `Your text is ${3 - value.length} char(s) too short.`;
      } else {
        return true;
      }
    },
  });
}

export function askForBody(): Promise<string> {
  return input({
    message: "body?",
  });
}

export function askForIssue(): Promise<string> {
  return input({
    message: "issue?",
  });
}

export function askForConfirmation(): Promise<boolean> {
  return confirm({
    message: "Is this okay?",
    default: true,
  });
}
